// import { useEffect } from 'react';
import React, { createRef } from 'react';

import Input from '../../../components/input-with-label';
import TextArea from '../../../components/textarea-with-label';

import {sanatizeString } from '../../../lib/helpers/formatters';

import { Editor } from '@tinymce/tinymce-react';
import LabelContainer from '../../../components/label-container';
import DOMPurify from 'dompurify';
import _ from 'lodash';
import ErrorContainer from '../../../components/error-container';

let extras = {
    entity_encoding : "raw",
    style_formats: [
        {
            title: 'Colors',
            items: ['removeformat'],
            remove: ['forecolor', 'backcolor']
        }
    ],
    menu: {
        format: {
            title: 'Format',
            items: 'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | language | removeformat'
        },
    },
    formats: {
        removeformat: [
          { selector: 'font, span, div, p, a, img, blockquote', remove: 'color, bgcolor, border, cellpadding, cellspacing, height, width, class, style' },
          { selector: 'h1, h2, h3, h4, h5, h6, td, th, code, pre', remove: 'color, bgcolor, border, cellpadding, cellspacing, height, width, class, style' },
          { selector: '*', attributes: ['style'] },
          { selector: 'span, div, p, a, img, blockquote', attributes: ['class'] },
          { selector: 'h1, h2, h3, h4, h5, h6, td, th, code, pre', attributes: ['class'] },
        ],
      },
    plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount'
    ],
    menubar: 'edit format',
    toolbar: 'undo redo | ' +
    'bold italic | alignleft aligncenter ' +
    'alignright alignjustify | bullist numlist outdent indent | ' +
    'removeformat | help',
}

export default class QuestionTypeTextInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props?.params?.value,
        }

        this.editorRef = createRef();
    }

    onComponentChange = _.debounce((e, editor) => {
        let sanatized = Object.assign({}, e, {
            target: Object.assign({}, e.target, {
                value : sanatizeString(e.target.value)
            })
        });

        if (this.props.question?.large_input === true) {
            sanatized.target.value = DOMPurify.sanitize(editor.getContent({ entity_encoding: 'raw' }));
        }

        console.log(e.target.value);

        this.setError(e);

        this.props.onChange(sanatized, this.props.blockId, this.props.question.id);
    }, 500, null)

    onSmallInputChange(e) {
        let sanatized = Object.assign({}, e, {
            target: Object.assign({}, e.target, {
                value : sanatizeString(e.target.value)
            })
        });

        this.setError(e);

        this.props.onChange(sanatized, this.props.blockId, this.props.question.id);
    }

    componentDidMount() {
        this.setError(null);
    }

    setError(e) {

        const { question, addError, params, sectionId } = this.props;

        let value = e !== null ? e.target.value : params.value;


        if (value !== null) {
            let errors = []

            if (question.response_required && value.length == 0) {
                errors.push('Answer cant be empty');
            }

            if (question.set_word_count) {
                console.log('Got to split', question, value);
                value = value.split(' ');
                console.log('Got after split', question, value);
                if (value.length < question.min_word_count) {
                    errors.push(`Need a minimum of ${question.min_word_count} words`);
                }

                if (value.length > question.max_word_count) {
                    errors.push(`There is a maximum word count of ${question.max_word_count}`);
                }
            }

           addError(errors.length > 0, errors, sectionId, question.id);
        } else {
            if (question.response_required) {

               addError(true, ['Please enter a response to proceed'], sectionId, question.id);
            }
        }
    }

    render() {
        const { question, error, showErrors, params } = this.props;

        const wordCount = `Min. ${question.min_word_count} words | ${params.value ? params.value.split(' ').length : 0 } / ${question.max_word_count}`;

        const newParams  = Object.assign({}, {
            placeholder: question.placeholder,
            fit: !question.set_word_count ? !question.small_input : true,
        }, params);

        const props = params;

        if (question.large_input === true) {
            return (
                <LabelContainer fill label={newParams?.label} description={newParams?.description}>
                    <ErrorContainer errors={showErrors && error} fill>
                        <Editor
                            onInit={(evt, editor) => this.editorRef.current = editor}
                            disabled={props.disabled}
                            value={this.state?.value}
                            onEditorChange={(value, editor) => {
                                if (!props.disabled) {
                                    this.setState({ value }, () => {
                                        this.onComponentChange({ target: { value }}, editor);
                                    })
                                }
                            }}
                            init={{
                                ...extras,
                                paste_data_images: false,
                                smart_paste: false,
                                paste_block_drop: false,
                                height: 500,
                                entity_encoding : "raw",
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                paste_preprocess: function (plugin, args) {
                                    // var parser = new DOMParser();
                                    // var decodedDocument = parser.parseFromString(args.content, 'text/html');
                                    // var decodedContent = decodedDocument.body.textContent;

                                    // let pastedData = decodedContent;
                                    // let modifiedData = decodedContent;

                                    // const regex = /<(img|iframe|video|audio|embed|picture)([^>]*)\/?>/g;
                                    // const matches = regex.exec(pastedData);

                                    // function encodeHTMLString(htmlString) {
                                    //     var parser = new DOMParser();
                                    //     var doc = parser.parseFromString('', 'text/html');
                                    //     doc.body.textContent = htmlString;
                                    //     return doc.body.innerHTML;
                                    // }

                                    // if (matches !== null) {
                                    //     console.log(matches)

                                    // }

                                    // args.content = modifiedData;
                                }
                            }}
                        />
                    </ErrorContainer>
                </LabelContainer>
            )
        }

        return <Input onChange={this.onSmallInputChange.bind(this)} errors={showErrors && error} { ...newParams } />
    }

}
